import React from 'react';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { TextField } from '@mui/material';
import ConnectedComponent from '../ConnectedComponent';
import Validator from '../../../library/validator';

class TextInputNew extends ConnectedComponent {
    constructor(props) {
        super(props);
    }
    onChange = (event) => {
        this.onUpdateState(event.target.value);
    }
    onBlur = (event) => {
        this.onUpdateStore(event.target.value, Validator.validate, types.FORM_INPUT);
    }
    render() {
        const p = this.props;
        const s = this.state || {};
        return (<div className="form-group">
                <TextField
                    id={p.id || p.name}
                    type={p.type}
                    floatingLabelText={p.floatingLabelText || p.hintText}
                    value={s.value}
                    errorText={s.error}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    {...p} />
        </div>);
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.errors && state.form.errors[props.name]
    };
};
export default connect(mapStateToProps)(TextInputNew);